export class Settings {
    private static beUrl: string = import.meta.env.VITE_BACKEND_BASE_URL as string;

    public static backEndBaseUrl(): string {
        return Settings.beUrl as string;
    }
}